import React from "react";
import Providers from "@bfc-software/bfc-web-ui/ui/shared/providers";
import { LocalStorage } from "@bfc-software/app-toolbox";
import { AppError, Toaster } from "@bfc-software/pallet";
import { createRootRoute, Outlet, redirect } from "@tanstack/react-router";
import { DEFAULT_LOCALE } from "@bfc-software/bfc-web-ui/i18n";

import "../globals.css";

export const Route = createRootRoute({
  loader: ({ location }) => {
    const token = LocalStorage.getStorageItem("token");
    const orgId = LocalStorage.getStorageItem("currentOrgSlug") ?? void 0;

    if (location.pathname !== "/") {
      return;
    }

    // A token and an org are enough. The tile screen has no warehouse, and the
    // products that need one resolve it themselves.
    if (typeof token == "undefined" || typeof orgId === "undefined") {
      throw redirect({
        to: "/$lang/auth/login",
        params: {
          lang: DEFAULT_LOCALE,
        },
      });
    }

    throw redirect({
      to: "/$lang/orgs/$org",
      params: {
        lang: DEFAULT_LOCALE,
        org: orgId,
      },
    });
  },
  component: () => (
    <Providers>
      <Outlet />
      <Toaster />
    </Providers>
  ),
  notFoundComponent: () => {
    return (
      <AppError
        description="We couldn't find a feature matching this path. It's possible the page has been moved or deleted."
        resolution="Try returning to the last page."
      />
    );
  },
});
